/* eslint-disable max-len */

import React, { Component } from 'react';
import { arrayOf, bool, func, number, object, oneOfType, shape, string } from 'prop-types';
import { connect } from 'react-redux';
import { css } from 'aphrodite';

import FlyoutNavLink from './FlyoutNavLink';
import FlyoutNavLinkGroup from './FlyoutNavLinkGroup';

import styles from './styles.js';

import { returnDropdownLinkGroups } from './methods';

import {
    toggleMobHelpDropdown,
    toggleMobVenueDropdown,
    toggleMobPerfDropdown,
    toggleMobInvoiceDropdown,
    toggleMobInventDropdown,
    toggleMobAdminHelpDropdown
} from '../../../../modules/navigation';

import {
    getDomain,
    getLang,
    getNavigation
} from '../../../../selectors';

class FlyoutNav extends Component {
    static propTypes = {
        domain: string.isRequired,
        navigation: shape({
            mobHelpDropdown: shape({
                isVisible: bool,
                linkGroups: arrayOf(number)
            }),
            mobVenueDropdown: shape({
                isVisible: bool,
                linkGroups: arrayOf(number)
            }),
            mobPerfDropdown: shape({
                isVisible: bool,
                linkGroups: arrayOf(number)
            }),
            mobInvoiceDropdown: shape({
                isVisible: bool,
                linkGroups: arrayOf(number)
            }),
            mobInventDropdown: shape({
                isVisible: bool,
                linkGroups: arrayOf(number)
            }),
            mobAdminHelpDropdown: shape({
                isVisible: bool,
                linkGroups: arrayOf(number)
            }),
            linkGroups: arrayOf(shape({
                id: number,
                title: shape({
                    transKey: string
                }),
                links: arrayOf(shape({
                    id: number.isRequired,
                    icon: string,
                    title: shape({
                        transKey: string.isRequired,
                        count: number,
                        replacements: object
                    }).isRequired,
                    url: string,
                    shown: bool
                }))
            })),
            user: shape({
                id: oneOfType([number, string]),
                isAdmin: bool,
                isLoggedIn: bool,
                adminModeId: number
            })
        }).isRequired,
        toggleMobAdminHelpDropdown: func.isRequired,
        toggleMobHelpDropdown: func.isRequired,
        toggleMobInventDropdown: func.isRequired,
        toggleMobInvoiceDropdown: func.isRequired,
        toggleMobPerfDropdown: func.isRequired,
        toggleMobVenueDropdown: func.isRequired
    }

    constructor(props) {
        super(props);
        const { mobHelpDropdown, mobVenueDropdown, mobPerfDropdown, mobInvoiceDropdown, mobInventDropdown, mobAdminHelpDropdown, linkGroups } = this.props.navigation;
        if (mobHelpDropdown) {
            this._mobHelpDropdownLinkGroups = returnDropdownLinkGroups(mobHelpDropdown, linkGroups);
        }
        if (mobVenueDropdown) {
            this._mobVenueDropdownLinkGroups = returnDropdownLinkGroups(mobVenueDropdown, linkGroups);
        }
        if (mobPerfDropdown) {
            this._mobPerfDropdownLinkGroups = returnDropdownLinkGroups(mobPerfDropdown, linkGroups);
        }
        if (mobInvoiceDropdown) {
            this._mobInvoiceDropdownLinkGroups = returnDropdownLinkGroups(mobInvoiceDropdown, linkGroups);
        }
        if (mobInventDropdown) {
            this._mobInventDropdownLinkGroups = returnDropdownLinkGroups(mobInventDropdown, linkGroups);
        }
        if (mobAdminHelpDropdown) {
            this._mobAdminHelpDropdownLinkGroups = returnDropdownLinkGroups(mobAdminHelpDropdown, linkGroups);
        }
    }

    _mobHelpDropdownLinkGroups = []
    _mobVenueDropdownLinkGroups = []
    _mobPerfDropdownLinkGroups = []
    _mobInvoiceDropdownLinkGroups = []
    _mobInventDropdownLinkGroups = []
    _mobAdminHelpDropdownLinkGroups = []

    handleToggleMobHelpDropdown = () => {
        if (!this.props.navigation.mobHelpDropdown.isVisible) {
            this.props.toggleMobHelpDropdown();
        }
    }

    handleToggleMobVenueDropdown = () => {
        if (!this.props.navigation.mobVenueDropdown.isVisible) {
            this.props.toggleMobVenueDropdown();
        }
    }

    handleToggleMobPerfDropdown = () => {
        if (!this.props.navigation.mobPerfDropdown.isVisible) {
            this.props.toggleMobPerfDropdown();
        }
    }

    handleToggleMobInvoiceDropdown = () => {
        if (!this.props.navigation.mobInvoiceDropdown.isVisible) {
            this.props.toggleMobInvoiceDropdown();
        }
    }

    handleToggleMobInventDropdown = () => {
        if (!this.props.navigation.mobInventDropdown.isVisible) {
            this.props.toggleMobInventDropdown();
        }
    }

    handleToggleMobAdminHelpDropdown = () => {
        if (!this.props.navigation.MobAdminHelpDropdown.isVisible) {
            this.props.toggleMobAdminHelpDropdown();
        }
    }

    render() {
        const { mobHelpDropdown, mobVenueDropdown, mobPerfDropdown, mobInvoiceDropdown, mobInventDropdown, mobAdminHelpDropdown, user } = this.props.navigation;
        return (
            <div
                tabIndex="-1"
                className={css(styles.childContainer)}
                role="menu"
            >
                <ul className={css(styles.container)}>
                    <FlyoutNavLink
                        title={{ transKey: 'common.home' }}
                        url={`/${this.props.domain}`}
                    />
                    {
                        user.isSpoofMode || (user.isLoggedIn && user.isAdmin) ?
                            <FlyoutNavLink
                                title={{
                                    transKey: user.isSpoofMode ?
                                        'nav.admin_unadopt' :
                                        'nav.admin_adopt'
                                }}
                                url={
                                    user.isSpoofMode ?
                                        `/${this.props.domain}/administrator/spoof/disengage` :
                                        `/${this.props.domain}/administrator/spoof/engage`
                                }
                            /> : null
                    }
                    {
                        user.isAdmin && !user.isSpoofMode ?
                            <FlyoutNavLink
                                title={{ transKey: 'nav.bookings' }}
                                url={`/${this.props.domain}/administrator/reservations`}
                            /> : null
                    }
                    {
                        user.isAdmin && !user.isSpoofMode ?
                            <FlyoutNavLink
                                title={{ transKey: 'Enquiries' }}
                                url={`/${this.props.domain}/administrator/enquiries`}
                            /> : null
                    }
                    {
                        user.isAdmin && !user.isSpoofMode ?
                            <FlyoutNavLinkGroup
                                title={{ transKey: 'Performance' }}
                                dropdown={mobPerfDropdown}
                                dropdownLinkGroups={this._mobPerfDropdownLinkGroups}
                                clickOutsideActive
                                toggleNavDropdown={this.props.toggleMobPerfDropdown}
                            /> : null
                    }
                    {
                        user.isAdmin && !user.isSpoofMode ?
                            <FlyoutNavLinkGroup
                                title={{ transKey: 'Payments' }}
                                dropdown={mobInvoiceDropdown}
                                dropdownLinkGroups={this._mobInvoiceDropdownLinkGroups}
                                clickOutsideActive
                                toggleNavDropdown={this.props.toggleMobInvoiceDropdown}
                            /> : null
                    }
                    {
                        user.isAdmin && !user.isSpoofMode ?
                            <FlyoutNavLinkGroup
                                title={{ transKey: 'Inventory' }}
                                dropdown={mobInventDropdown}
                                dropdownLinkGroups={this._mobInventDropdownLinkGroups}
                                clickOutsideActive
                                toggleNavDropdown={this.props.toggleMobInventDropdown}
                            /> : null
                    }
                    {
                        user.isAdmin && !user.isSpoofMode ?
                            <FlyoutNavLink
                                title={{ transKey: 'Users' }}
                                url={`/${this.props.domain}/administrator/users`}
                            /> : null
                    }
                    {
                        user.isAdmin && !user.isSpoofMode ?
                            <FlyoutNavLinkGroup
                                title={{ transKey: 'Helpers' }}
                                dropdown={mobAdminHelpDropdown}
                                dropdownLinkGroups={this._mobAdminHelpDropdownLinkGroups}
                                clickOutsideActive
                                toggleNavDropdown={this.props.toggleMobAdminHelpDropdown}
                            /> : null
                    }
                    {
                        (!user.isAdmin || user.isSpoofMode) && user.isVenueOwner ?
                            <FlyoutNavLink
                                title={{ transKey: 'nav.add_new_listing' }}
                                url={`/${this.props.domain}/dashboard/listings`}
                            /> : null
                    }
                    {
                        (!user.isAdmin || user.isSpoofMode) && user.isVenueOwner ?
                            <FlyoutNavLinkGroup
                                title={{ transKey: 'nav.venue' }}
                                dropdown={mobVenueDropdown}
                                dropdownLinkGroups={this._mobVenueDropdownLinkGroups}
                                clickOutsideActive
                                toggleNavDropdown={this.props.toggleMobVenueDropdown}
                            /> :
                            !user.isAdmin || user.isSpoofMode ?
                                <FlyoutNavLink
                                    title={{ transKey: 'nav.list_your_space' }}
                                    url={
                                        !user.isLoggedIn ?
                                            `/${this.props.domain}/list/overview` :
                                            user.isVenueOwner ?
                                                `/${this.props.domain}/dashboard/listings` :
                                                `/${this.props.domain}/venues/new`
                                    }
                                /> : null
                    }
                    {
                        user.isLoggedIn && !user.isVenueOwner && (!user.isAdmin || user.isSpoofMode) ?
                            <FlyoutNavLink
                                title={{ transKey: 'nav.favourites' }}
                                url={`/${this.props.domain}/dashboard/favourites`}
                            /> : null
                    }
                    {
                        (!user.isAdmin || user.isSpoofMode) && user.isVenueOwner ?
                            <FlyoutNavLink
                                title={{ transKey: 'nav.schedule' }}
                                url={`/${this.props.domain}/dashboard/schedule`}
                            /> : null
                    }
                    {
                        user.isLoggedIn && (!user.isAdmin || user.isSpoofMode) ?
                            <FlyoutNavLink
                                title={{ transKey: 'nav.bookings' }}
                                url={
                                    user.isVenueOwner ?
                                        `/${this.props.domain}/dashboard/venue-bookings` :
                                        `/${this.props.domain}/dashboard/bookings`
                                }
                            /> : null
                    }
                    {
                        user.isLoggedIn && (!user.isAdmin || user.isSpoofMode) ?
                            <FlyoutNavLink
                                title={{ transKey: 'nav.inbox' }}
                                url={`/${this.props.domain}/dashboard/inbox`}
                            /> : null
                    }
                    {
                        (!user.isAdmin || user.isSpoofMode) && user.isVenueOwner ?
                            <FlyoutNavLink
                                newText
                                title={{ transKey: 'nav.widget' }}
                                url={`/${this.props.domain}/dashboard/widget`}
                            /> : null
                    }
                    {
                        !user.isAdmin || user.isSpoofMode ?
                            <FlyoutNavLinkGroup
                                title={{ transKey: 'common.help' }}
                                dropdown={mobHelpDropdown}
                                dropdownLinkGroups={this._mobHelpDropdownLinkGroups}
                                clickOutsideActive
                                toggleNavDropdown={this.props.toggleMobHelpDropdown}
                            /> : null
                    }
                    {
                        !user.isLoggedIn ?
                            <FlyoutNavLink
                                title={{ transKey: 'common.sign_up' }}
                                url={`/${this.props.domain}/users/signup`}
                            /> : null
                    }
                    {
                        !user.isLoggedIn ?
                            <FlyoutNavLink
                                title={{ transKey: 'common.login' }}
                                url={`/${this.props.domain}/users/signin`}
                            /> :
                            <FlyoutNavLink
                                title={{ transKey: 'common.logout' }}
                                url={`/${this.props.domain}/users/logout`}
                            />
                    }
                </ul>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    domain: getDomain(state),
    lang: getLang(state),
    navigation: getNavigation(state)
});

const mapDispatchToProps = dispatch => ({
    toggleMobHelpDropdown: () => dispatch(toggleMobHelpDropdown()),
    toggleMobVenueDropdown: () => dispatch(toggleMobVenueDropdown()),
    toggleMobPerfDropdown: () => dispatch(toggleMobPerfDropdown()),
    toggleMobInvoiceDropdown: () => dispatch(toggleMobInvoiceDropdown()),
    toggleMobInventDropdown: () => dispatch(toggleMobInventDropdown()),
    toggleMobAdminHelpDropdown: () => dispatch(toggleMobAdminHelpDropdown())
});

export default connect(mapStateToProps, mapDispatchToProps)(FlyoutNav);



// WEBPACK FOOTER //
// ./src/components/Header/FlyoutMenu/FlyoutNav/FlyoutNav.jsx